import React,{  } from 'react'
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import "../css/Project.css"

const Project = ({projectImage,projectName,projectDesc,projectRepoUrl,projectUrl,projectTech}) => {

  
  

  return (
    <Card className='projectCard' sx={{ width: "75%",boxShadow:3 }}>
      <CardMedia
        component="img"
        alt="green iguana"
        height="140"
        image={projectImage}
       
      />
      <CardContent>
        <h3 className='projectName'>{projectName}</h3>
        <p className='projectDesc'>
        {projectDesc}
        </p>

        <div className="projectTechDiv">
            {
              projectTech.map(item=>{
                return(
                  <img className='techIcon' src={item} alt="" srcset="" />
                )
              })
            }

          
        </div>
      </CardContent>
      <CardActions>
        {projectRepoUrl ?
      <a href={projectRepoUrl}>
      <img className='cardBtns' src="https://cdn-icons-png.flaticon.com/512/25/25231.png" ></img></a>
        :
        ''
        }
       
        {projectUrl ?
         <a href={projectUrl}>
         <img className='cardBtns' src="https://cdn-icons-png.flaticon.com/512/7794/7794669.png" ></img></a>
        :''
        }
         
      </CardActions>
    </Card>
  )
}

export default Project